export default "__VITE_ASSET__CA085JBM__ 584w";